import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GROUP_GET = createApiNamespacedConstants('GROUP_GET');
export const GROUP_UPDATE = createApiNamespacedConstants('GROUP_UPDATE');
export const GROUP_SET_CONCURRENCY = createApiNamespacedConstants('GROUP_SET_CONCURRENCY');
export const GROUP_USERLIST_GET = createApiNamespacedConstants('GROUP_USERLIST_GET');
export const TEAM_REMOVE_FROM_GROUP = createApiNamespacedConstants('TEAM_REMOVE_FROM_GROUP');
export const GET_GROUP_TEAMS_USAGE_CSV = createApiNamespacedConstants('GET_GROUP_TEAMS_USAGE_CSV');

export const INITIALIZE = `${NAMESPACE}/INITIALIZE`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const TOGGLE_TEAM_SELECTION = `${NAMESPACE}/TOGGLE_TEAM_SELECTION`;
export const TOGGLE_ALL_TEAMS_SELECTION = `${NAMESPACE}/TOGGLE_ALL_TEAMS_SELECTION`;
export const TOGGLE_USER_SELECTION = `${NAMESPACE}/TOGGLE_USER_SELECTION`;
export const SET_USERS_SELECTION = `${NAMESPACE}/SET_USERS_SELECTION`;
export const UPDATE_USERLIST_OFFSET = `${NAMESPACE}/UPDATE_USERLIST_OFFSET`;
